/**
 * @desc 站点店铺-分页查询【含数据权限过滤】
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.PlatformSiteShopResponseDto>
>;
export function request(
  params: API.basics.platformSiteShop.pageDataList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformSiteShop/data/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
